<template>
  <!--单个用户样式-->
  <card
    :height="50"
    :width="100"
    class="p-12"
  >
    <tk-flex middle between>
      <tk-flex middle>
        <tk-avatar size="50">
          <tk-image :src="userSingle.avatar" width="50" height="50"></tk-image>
        </tk-avatar>
        <div class="m-l-8">
          <div class="font-14 font-bold">{{userSingle.name}}</div>
          <tk-flex class="caption m-t-10">
            <div>发帖 {{userSingle.postsSum | transform}}</div>
            <div class="m-l-10">粉丝 {{userSingle.fansSum | transform}}</div>
          </tk-flex>
        </div>
      </tk-flex>
      <tkui-button
        primary rounded border
        :raised="false"
        class="watch-single"
        @click="watchUser"
        :class="{'watch-active': userSingle.watchStatus}"
        :disabled="watchDisabled || userSingle.watchStatus"
      >{{userSingle.watchStatus ? '已关注' : '未关注'}}</tkui-button>
    </tk-flex>
  </card>
</template>

<script>
import { judgePosts } from '@/assets/help/posts'
export default {
  data () {
    return {
      watchDisabled: false // 关注状态
    }
  },
  props: {
    userSingle: {
      type: Object
    },
    type: {
      type: String,
      default: 'watch'
    },
    profileId: {
      type: String
    }
  },
  methods: {
    /**
    * 关注用户
    * @date: 2020/4/13
    */
    async watchUser () {
      if (this.userSingle.watchStatus) { return }
      if (this.profileId === this.userSingle.objectId) { return this.$tkGlobal.toast.add('不能关注自己哦') }
      this.watchDisabled = true
      // 数据
      let obj = {
        author: this.userSingle.objectId,
        userFans: this.profileId
      }
      let whereObj = { userFans: this.profileId, author: this.userSingle.objectId }
      if (this.type !== 'watch') {
        whereObj = { userFans: this.profileId, author: this.userSingle.objectId }
      }
      let watchStatus = await judgePosts('watchPostUser', whereObj)
      // 判断关注作者
      if (this.userSingle.watchStatus || watchStatus) {
        this.watchDisabled = false
        return this.$tkGlobal.toast.add('您已经关注了该作者')
      }
      // 给关注列表添加数据
      await this.$tkParse.post(`/classes/watchPostUser`, obj)
      this.$tkGlobal.toast.add('关注成功')
      this.userSingle.watchStatus = true
      await this.$tkHelper.sleep(500)
      this.watchDisabled = false
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
/*关注样式*/
  .watch-single {
    min-width: 64px;
    height: 28px;
    border: 1px solid rgba(255, 96, 0, 1);
    border-radius: 14px;
    text-align: center;
    line-height: 28px;
    color: #FF6000;
  }
  .watch-active {
    background: rgba(255, 255, 255, 0);
    border: 1px solid #999;
  }
  ::v-deep .tkui-button.primary.border:hover {
    background-color: rgba(255, 255, 255, 0);
    color: #FF6000;
  }
</style>
